export default {
  ageOptions: {
    le17: {
      en: 'Under 17',
    },
    from18to24: {
      en: '18 to 24',
    },
    from25to34: {
      en: '25 to 34',
    },
    from35to44: {
      en: '35 to 44',
    },
    from45to54: {
      en: '45 to 54',
    },
    from55to64: {
      en: '55 to 64',
    },
    from65: {
      en: '65 or older',
    },
    notAnswer: {
      en: 'Prefer not to answer',
    },
  },
}
